/* eslint-disable security/detect-unsafe-regex */
/* eslint-disable sonarjs/no-duplicate-string */
import React, { FC } from 'react'
import LayoutDefault from '@/components/layouts/Layout'
import SectionHeaderService from '@/components/modules/SectionHeaderService'
import TitleShadow from '@/components/modules/TitleShadow'
import ListBullet from '@/components/modules/ListBullet'
import ServiceItem from '@/components/modules/ServiceItem'
import PortfolioItem from '@/components/modules/PortfolioItem'
import WarrantyItem from '@/components/modules/WarrantyItem'
import ServiceGetInTouch from '@/components/modules/ServiceGetInTouch'
import Button from '@/components/elements/Button'
import ImgResponsive from '@/components/elements/ImgResponsive'
import Router from 'next/router'
import { FaArrowRight } from 'react-icons/fa'
import Link from 'next/link'

const ServicePage: FC = () => {
  return (
    <LayoutDefault>
      <SectionHeaderService
        bgColors='#FFCA64'
        bgImage='/images/service/Twin_Service_Design.webp'
        bgImageMd='/images/service/Twin_Service_Design.webp'
        bgImageSm='/images/service/Twin_Service_Design.webp'
        title={
          <>&quot;การออกแบบเว็บไซต์ที่เจ๋ง ช่วยเพิ่มโอกาสที่ดีให้กับธุรกิจของคุณนะ รู้ยัง&quot;</>
        }
        description='"Transforming Your Business into Digital Reality"'
        bgImageWidth={1214}
        bgImageHeight={534}
        btnText='ปรึกษาทีมออกแบบ'
        onClick={() => Router.push('/contact-service')}
        prologue='ออกแบบ'
        colorPrologue='rgba(0,0,0,.08)'
        titleShadow='ออกแบบเว็บไซต์'
        colorTitleShadow='#000000'
        align='center'
        content={
          <>
            <p className='text-center'>
              การออกแบบเว็บไซต์ (Design & Re-Design Website) รวมถึงการปรับปรุงหน้าตาของเว็บไซต์
              (Re-Design Website) ให้มีความสวยงาม
              และมีการจัดวางที่น่าสนใจนั้นจะช่วยดึงดูผู้เข้าชมเว็บไซต์ให้มากขึ้น
              เป็นการเพิ่มโอกาสทางธุรกิจอย่างหนึ่งที่หลาย ๆ ธุรกิจไม่ควรมองข้าม ซึ่งได้แก่
              ธุรกิจโรงแรม ร้านอาหาร แฟชั่น หรือแม้แต่แบรนด์สินค้าต่าง ๆ เป็นต้น
              เว็บไซต์เปรียบเสมือนหน้าตาของธุรกิจบนโลกออนไลน์
              ซึ่งจะช่วยเพิ่มความน่าเชื่อถือให้กับธุรกิจของท่าน
              การออกแบบเว็บไซต์ที่ดีต้องคำนึงถึงความสอดคล้องกับแบรนด์
              และสามารถนำเสนอข้อมูลอันเป็นประโยชน์ไปยังกลุ่มเป้าหมายของธุรกิจได้อย่างชัดเจน
            </p>
            <p className='text-center'>
              เรามีทีมออกแบบเว็บไซต์ที่ชำนาญและมีความคิดสร้างสรรค์ ที่สามารถทำการออกแบบเว็บไซต์
              (Design Website) หรือปรับปรุงหน้าตาของเว็บไซต์ (Re-Design Website)
              ของท่านที่ให้ดูสวยงาม ดูน่าสนใจ แต่ยังคงไว้ซึ่งความเป็นเอกลักษณ์ของธุรกิจ ใช้งานง่าย
              (User Friendly) มุ่งเน้นความประทับใจของผู้ใช้งานแต่ก็ไม่ขัดกับหลักในการพัฒนาเว็บไซต์
            </p>
            <div className='text-center'>
              <Button
                htmlType='button'
                className='btn-neutral'
                onClick={() => Router.push('/contact-service')}
              >
                ประเมินราคาฟรี
              </Button>
            </div>
          </>
        }
      />
      <div className='pb-24 lg:pb-0 xl:pt-44'>
        <div className='container mx-auto space-y-8 px-4 lg:pt-44 xl:pt-0'>
          <TitleShadow
            prologue='Experiences'
            colorPrologue='rgba(0,0,0,.08)'
            title={<>Experiences</>}
            colorTitle='#000000'
            align='center'
            rootClassName='mb-16'
          />
          <div className='space-y-4 pb-16 lg:pb-24'>
            <ListBullet
              className='grid grid-cols-1 lg:grid-cols-3'
              list={[
                'Radio Steaming App',
                'VDO Streaming App',
                'Music Steaming App',
                'Loyalty App',
                'E-Sport tournament App',
                'E-Community App',
                'E-Booking App',
                'ETC.',
              ]}
            />
            <ImgResponsive
              src='/images/service/middle_sevice_design.webp'
              alt='Twin Synergy service'
              sourceImgSm='/images/service/middle_sevice_design.webp'
              sourceImgMd='/images/service/middle_sevice_design.webp'
              loadingLazy
              className='mx-auto'
            />
          </div>
        </div>
      </div>
      <div className='bg-neutral py-28'>
        <div className='container mx-auto space-y-8 px-4'>
          <div className='grid grid-cols-1 items-center gap-4 text-white lg:grid-cols-2 xl:gap-8'>
            <ImgResponsive
              src='/images/service/service_contact.webp'
              alt='Twin Synergy service'
              sourceImgSm='/images/service/service_contact.webp'
              sourceImgMd='/images/service/service_contact.webp'
              loadingLazy
              className='mx-auto'
            />
            <div className='space-y-6'>
              <h2 className='xl:text-7xl'>
                อย่างเพิ่งตัดสินใจ
                <br />
                ถ้ายังไม่ได้คุยกับเรา ยินดีให้คำปรึกษา
              </h2>
              <p className='font-bold xl:text-4xl'>
                เรื่องการออกแบบเว็บไซต์และปรับปรุงหน้าตาเว็บไซต์ รวมถึงประเมินราคาให้ได้เลย
              </p>
              <Button
                htmlType='button'
                className='btn-warning'
                onClick={() => Router.push('/contact')}
              >
                บอกความต้องการของคุณ
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className='pt-24 lg:pt-44'>
        <div className='container mx-auto space-y-8 px-4 pb-14 xl:pt-0'>
          <TitleShadow
            prologue='ผลงาน'
            colorPrologue='rgba(0,0,0,.08)'
            title={<>ผลงานของเรา</>}
            colorTitle='#000000'
            align='center'
          />
        </div>
        <div className='grid grid-cols-2 lg:grid-cols-4'>
          <PortfolioItem
            title='Srichand'
            categories='website'
            serviceImg='/images/service/design/Srichand.webp'
            serviceBg='#FFCA64'
          />
          <PortfolioItem
            title='The Cliff Lipe'
            categories='website'
            serviceImg='/images/service/design/The_Cliff_Lipe.webp'
            serviceBg='#FFCA64'
            slug='/portfolio/the-cliff-lipe/'
          />
          <PortfolioItem
            title={
              <>
                Tongna Cottage
                <br />
                Natural Resort
              </>
            }
            categories='website'
            serviceImg='/images/service/design/Tongna_Cottage_Natural_Resort.webp'
            serviceBg='#FFCA64'
            slug='/portfolio/'
          />
          <PortfolioItem
            title='Sweet Nation'
            categories='website'
            serviceImg='/images/service/design/Sweet_Nation.webp'
            serviceBg='#FFCA64'
          />
        </div>
        <div className='bg-neutral text-center'>
          <Link
            className='flex items-center justify-center py-4 font-light text-white'
            href='/portfolio'
          >
            ดูโปรเจกต์ทั้งหมด <FaArrowRight className='ml-2' size={14} />
          </Link>
        </div>
        <div className='warranty grid grid-cols-2 lg:grid-cols-4'>
          <WarrantyItem
            content={<>แก้ไขดีไซน์ได้ 5 ครั้ง</>}
            serviceImg='/images/service/design/ui-ux-design.webp'
            serviceBg='#F7F8F9'
          />
          <WarrantyItem
            content={<>คอยช่วยเหลือตลอด 6 เดือน</>}
            serviceImg='/images/service/design/ma-service.webp'
            serviceBg='#F7F8F9'
          />
          <WarrantyItem
            content='ประสานงานกับทีมพัฒนา'
            serviceImg='/images/service/design/announce.webp'
            serviceBg='#F7F8F9'
          />
          <WarrantyItem
            content={<>ให้คำปรึกษาฟรี ตลอดชีพ</>}
            serviceImg='/images/service/free_consultant.webp'
            serviceBg='#F7F8F9'
          />
        </div>
      </div>
      <div className='bg-author-base py-24'>
        <div className='container mx-auto'>
          <ServiceGetInTouch content='“ไก่งามเพราะขน คนงามเพราะเล็บ เว็บงามเพราะเรา” ทวิน ซินเนอร์จี้ กล่าวไว้ติดต่อมาเลย....' />
        </div>
      </div>
      <div className='section-service pt-24 lg:pt-44'>
        <div className='container mx-auto space-y-8 px-4 pb-14 xl:pt-0'>
          <TitleShadow
            prologue='บริการ'
            colorPrologue='rgba(0,0,0,.08)'
            title='บริการอื่น ๆ'
            colorTitle='#000000'
            align='center'
          />
        </div>
        <div className='grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4'>
          <ServiceItem
            prologue='01'
            title='พัฒนาเว็บไซต์'
            serviceImg='/images/service/service-01.webp'
            serviceBg='#06B7B7'
            serviceUrl='website-development'
          />
          <ServiceItem
            prologue='02'
            title='พัฒนาแอปพลิเคชั่นมือถือ'
            serviceImg='/images/service/service-02.webp'
            serviceBg='#1990FF'
            serviceUrl='mobile-application-development'
          />
          <ServiceItem
            prologue='03'
            title='ออกแบบเว็บไซต์'
            serviceImg='/images/service/service-03.webp'
            serviceBg='#FFCA64'
            serviceUrl='website-design'
          />
          <ServiceItem
            prologue='04'
            title='เว็บไซต์สำหรับธุรกิจ SME'
            serviceImg='/images/service/service-04.webp'
            serviceBg='#FFAC79'
            serviceUrl='sme-website-development'
          />
          <ServiceItem
            prologue='05'
            title='ออกแบบและพัฒนา Line OA'
            serviceImg='/images/service/service-05.webp'
            serviceBg='#00BE00'
            serviceUrl='line-oa-development'
          />
          <ServiceItem
            prologue='06'
            title='พัฒนาซอฟต์แวร์ตามกำหนด'
            serviceImg='/images/service/service-06.webp'
            serviceBg='#FF7D7D'
            serviceUrl='custom-software-development'
          />
          <ServiceItem
            prologue='07'
            title='เพิ่มความปลอดภัย'
            serviceImg='/images/service/no-service.webp'
            serviceBg='#B577E5'
            noLink
          />
          <ServiceItem
            prologue='08'
            title='ดูแลบำรุงรักษาเว็บไซต์'
            serviceImg='/images/service/no-service.webp'
            serviceBg='#484848'
            noLink
          />
        </div>
      </div>
    </LayoutDefault>
  )
}

export default ServicePage
